import { exhaustMap, map, tap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppStore } from '@navstation-portal/reporting/data-access/app';
import { generateLocalReportId } from '@navstation-portal/reporting/data-model/engine-reports';
import { VesselSpecStore } from '@navstation-portal/vessels/data-access/store';
import { mapResponse } from '@ngrx/operators';
import { signalStoreFeature } from '@ngrx/signals';
import { Dispatcher, Events, withEventHandlers } from '@ngrx/signals/events';
import { EngineReportService } from '../engine-report-service/engine-report.service';
import { getEngineReportRoute } from '../utils/engine-report.store.utility';
import { engineReportEvents } from './engine-report-events';
import { getCylinderCount } from './tabs/cylinder-units/cylinder-units-vm';

export function withEngineReportEffects() {
  return signalStoreFeature(
    withEventHandlers(() => {
      const events = inject(Events);
      const dispatcher = inject(Dispatcher);
      const router = inject(Router);
      const appStore = inject(AppStore);
      const engineReportService = inject(EngineReportService);
      const vesselSpecStore = inject(VesselSpecStore);

      return {
        createReport$: events.on(engineReportEvents.createReport).pipe(
          tap(({ payload: { reportType } }) => {
            const vesselId = appStore.selectedVesselId();
            if (!vesselId) return;

            const localReportId = generateLocalReportId();
            dispatcher.dispatch(engineReportEvents.createReportSuccess({ localReportId, reportType }));
            router.navigate(getEngineReportRoute(vesselId, localReportId));
          })
        ),
        openReport$: events.on(engineReportEvents.openReport).pipe(
          exhaustMap(({ payload: { vesselId, reportId } }) =>
            engineReportService.getMainEngineReport(vesselId, reportId).pipe(
              mapResponse({
                next: (report) => engineReportEvents.openReportSuccess({ report }),
                error: (error: Error) => engineReportEvents.openReportFailed({ error: error.message }),
              })
            )
          )
        ),
        // Rows past the new engine's cylinder count are hidden, so drop them before they get saved.
        selectEngine$: events.on(engineReportEvents.selectEngine).pipe(
          map(({ payload: { engineIndex } }) =>
            engineReportEvents.trimCylinderUnits({
              count: getCylinderCount(engineIndex, vesselSpecStore.vesselSpec()),
            })
          )
        ),
      };
    })
  );
}
